var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup263(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 52,
    viewBox: "0 0 89 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 30,
    height: 52,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(-257 -1619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(257 1619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M25.241,0H4.01A4.014,4.014,0,0,0,0,4.01V47.991A4.014,4.014,0,0,0,4.01,52H25.241a4.014,4.014,0,0,0,4.01-4.01V4.01A4.014,4.014,0,0,0,25.241,0M8.125,1.625h13V2.844a.789.789,0,0,1-.813.813H8.938a.789.789,0,0,1-.813-.813Zm19.5,46.366a2.392,2.392,0,0,1-2.385,2.385H4.01a2.392,2.392,0,0,1-2.385-2.385V4.01A2.392,2.392,0,0,1,4.01,1.625H6.5V2.844A2.413,2.413,0,0,0,8.938,5.281H20.313A2.413,2.413,0,0,0,22.75,2.844V1.625h2.49A2.392,2.392,0,0,1,27.625,4.01Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M87.25,102a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,102m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -88.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M27.25,102a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,102m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -88.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M147.25,102a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -90.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M87.25,162a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,162m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M27.25,162a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,162m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M147.25,162a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M87.25,222a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,222m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M27.25,222a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,222m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M147.25,222a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M87.25,282a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,282m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -243.813)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(316 1619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213-2",
    "data-name": "Group 213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212-2",
    "data-name": "Group 212",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209-2",
    "data-name": "Path 209",
    d: "M25.241,0H4.01A4.014,4.014,0,0,0,0,4.01V47.991A4.014,4.014,0,0,0,4.01,52H25.241a4.014,4.014,0,0,0,4.01-4.01V4.01A4.014,4.014,0,0,0,25.241,0M8.125,1.625h13V2.844a.789.789,0,0,1-.813.813H8.938a.789.789,0,0,1-.813-.813Zm19.5,46.366a2.392,2.392,0,0,1-2.385,2.385H4.01a2.392,2.392,0,0,1-2.385-2.385V4.01A2.392,2.392,0,0,1,4.01,1.625H6.5V2.844A2.413,2.413,0,0,0,8.938,5.281H20.313A2.413,2.413,0,0,0,22.75,2.844V1.625h2.49A2.392,2.392,0,0,1,27.625,4.01Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215-2",
    "data-name": "Group 215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214-2",
    "data-name": "Group 214",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210-2",
    "data-name": "Path 210",
    d: "M87.25,102a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,102m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -88.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211-2",
    "data-name": "Path 211",
    d: "M27.25,102a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,102m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -88.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212-2",
    "data-name": "Path 212",
    d: "M147.25,102a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -90.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213-2",
    "data-name": "Path 213",
    d: "M87.25,162a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,162m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214-2",
    "data-name": "Path 214",
    d: "M27.25,162a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,162m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215-2",
    "data-name": "Path 215",
    d: "M147.25,162a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -140.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216-2",
    "data-name": "Path 216",
    d: "M87.25,222a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,222m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217-2",
    "data-name": "Path 217",
    d: "M27.25,222a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,27.25,222m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-20.75 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218-2",
    "data-name": "Path 218",
    d: "M147.25,222a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-124.5 -191.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219-2",
    "data-name": "Path 219",
    d: "M87.25,282a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,87.25,282m0,4.875a1.625,1.625,0,1,1,1.625-1.625,1.624,1.624,0,0,1-1.625,1.625",
    transform: "translate(-72.625 -243.813)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-right",
    "data-name": "Icon awesome-long-arrow-alt-right",
    d: "M8.059,12.058H-12.692a.308.308,0,0,0-.308.308V13.8a.308.308,0,0,0,.308.308H8.059v1.182a.616.616,0,0,0,1.052.436L11.32,13.52a.616.616,0,0,0,0-.871L9.11,10.44a.616.616,0,0,0-1.052.436Z",
    transform: "translate(302.25 1629.089)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup263);
export default __webpack_public_path__ + "static/media/Group263.06e27cecd0e5aa23ca87ad63677bb95c.svg";
export { ForwardRef as ReactComponent };